import { MapRoom, readPosition } from './mapDesign';
import { WorldPosition } from './protocol';

// Browser clients need an entrance interaction before the room barrier. The
// physical Stage 5 trigger remains useful after teleporting inside the room.
const BREAKOUT_ROOM = /^intersect-room-0?([1-5])$/;

/** Returns the browser bridge area id for the nearest room entrance. */
export function nearbyBreakoutArea(position: WorldPosition, rooms: MapRoom[], radius = 14): string | undefined {
  let nearest: { areaId: string; distance: number } | undefined;
  for (const room of rooms) {
    const match = room.room_id.match(BREAKOUT_ROOM);
    const spawn = readPosition(room.spawn_position);
    if (!match || !spawn || Math.abs(spawn.y - position.y) > 3.5) continue;
    const distance = Math.hypot(spawn.x - position.x, spawn.z - position.z);
    if (distance <= radius && (!nearest || distance < nearest.distance)) {
      const roomNumber = Number(match[1]);
      nearest = { areaId: roomNumber === 5 ? 'stage-5' : `breakout-room-${roomNumber}`, distance };
    }
  }
  return nearest?.areaId;
}
